import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot
} from '@angular/router';
import { CrudService } from 'app/shared/crud-service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { VendedorDTO } from './vendedor.model';

@Injectable({
  providedIn: 'root'
})
export class VendedoresService extends CrudService<VendedorDTO> implements Resolve<any> {
  constructor(protected http: HttpClient) {
      super(http, `${environment.apiUrl}/v1/Vendedor`);
  }

  resolve(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
      return new Promise<void>((resolve, reject) => {
          Promise.all([this.getAll()]).then(() => {
              resolve();
          }, reject);
      });
  }

    search(nome: string): Observable<any> {
        return this.http.get(`${environment.apiUrl}/v1/Vendedor/GetVendedores/${nome}`);
    }
}
